import { DoBootstrap, Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { SegmentItemElement } from './segment-item.component';
import { createCustomElement } from '@angular/elements';
import { TranslocoModule } from '@jsverse/transloco';

@NgModule({
    declarations: [SegmentItemElement],
    imports: [CommonModule, RouterModule, TranslocoModule],
    exports: [SegmentItemElement],
})
export class SegmentItemModule implements DoBootstrap {
    constructor(private injector: Injector) {}

    ngDoBootstrap(): void {
        const el = createCustomElement(SegmentItemElement, {
            injector: this.injector,
        });

        customElements.define('bazis-segment-item', el);
    }
}
